<ng-container *transloco="let t">
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingVatCondition') }}</div>
    <div class="order-section-item-value">{{ vatCondition() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingName') }}</div>
    <div class="order-section-item-value">{{ billingName() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingDocument') }}</div>
    <div class="order-section-item-value">
      {{ billingDocument() }}
    </div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">
      {{
        isVatConditionBusiness()
          ? t('orderDetails.billingBusinessAddress')
          : t('orderDetails.billingAddress')
      }}
    </div>
    <div class="order-section-item-value">{{ billingAddress() }}</div>
  </div>

  @if (adminMode()) {
    @if (!taxVoucherBilled() && requiredDataCompleted() && isNotCanceled()) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.billingTitle') }}</div>
        <div class="order-section-item-value">
          <pxw-button
            style="margin-left: 10px"
            size="sm"
            [rounded]="true"
            display="inline"
            color="yellow"
            [loading]="generatingTaxVoucher()"
            (click)="onGenerateTaxVoucher()"
          >
            <pxw-icon icon="billing-voucher" />
            {{ t('orderDetails.generateTaxVoucher') }}
          </pxw-button>
        </div>
      </div>
    }

    @let taxVoucher = orderDetails().taxVoucher;

    @if (taxVoucher) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.taxVoucher') }}</div>
        <div class="order-section-item-value">
          <div style="display: flex; align-items: center; gap: 10px">
            @if (generatingCreditNote()) {
              <pxw-button
                size="sm"
                [rounded]="true"
                display="inline"
                color="silver"
                [disabled]="true"
                [loading]="true"
              >
                {{ t('Generando nota de crédito...') }}
              </pxw-button>
            } @else {
              <app-order-details-tax-voucher-actions
                [billingInformation]="billingInformation()!"
                [orderDetails]="orderDetails()"
                [taxVoucher]="taxVoucher"
                (generateCreditNote)="onGenerateCreditNote()"
              />
            }
          </div>
        </div>
      </div>
    }
  }
</ng-container>
